const maxOfGraph = (data) => {
  if (!data) return 10;
  let max = data.reduce((acc, el) => {
    const max2 = el.data.reduce(
      (accu, el2) => (+el2.y > accu ? +el2.y : accu),
      0
    );
    return max2 > acc ? max2 : acc;
  }, 0);
  if (max > 10) {
    const str = Math.ceil(max).toString();
    max = Number(Number(str.slice(0, 1)) + 1 + new Array(str.length).join("0"));
  } else if (max > 5) max = 10;
  else max = 5;
  return max;
};
const maxOfGraphMultipleBar = (data, keys, groupMode) => {
  if (!data || !keys) return 10;
  let max = data.reduce((acc, el) => {
    // const max = keys.reduce((acc2, val) => el[val] + acc2, 0);
    const max = keys.reduce((acc2, val) => {
      if (groupMode === "grouped") return acc2 > el[val] ? acc2 : el[val];
      return keys.reduce((acc2, val) => el[val] + acc2, 0);
    }, 0);
    return max > acc ? max : acc;
  }, 0);
  if (max > 10) {
    const str = Math.ceil(max).toString();
    max = Number(Number(str.slice(0, 1)) + 1 + new Array(str.length).join("0"));
  } else if (max > 5) max = 10;
  else max = 5;
  return max;
};
const getGridYValues = (data) => {
  if (!data) return [0, 2, 4, 6, 8, 10];
  const max = maxOfGraph(data);

  const slice = Math.ceil(max / 5);
  return [0, 1, 2, 3, 4, 5].map((grid) => slice * grid);
};

const getGridYValuesMultipleBar = (data, keys, groupMode) => {
  if (!data) return [0, 2, 4, 6, 8, 10];
  const max = maxOfGraphMultipleBar(data, keys, groupMode);
  const slice = Math.ceil(max / 5);
  return [0, 1, 2, 3, 4, 5].map((grid) => slice * grid);
};

const maxOfGraphBar = (data, keyValue) => {
  if (!data) return 10;

  let max = data.reduce((acc, el) => {
    return +el[keyValue] > acc ? +el[keyValue] : acc;
  }, 0);

  if (max > 10) {
    const str = Math.ceil(max).toString();

    max = Number(Number(str.slice(0, 1)) + 1 + new Array(str.length).join("0"));
  } else if (max > 5) max = 10;
  else max = 5;

  return max;
};
const getGridYValuesBar = (data, keyValue) => {
  if (!data) return [0, 2, 4, 6, 8, 10];

  const max = maxOfGraphBar(data, keyValue);

  const slice = Math.ceil(max / 5);

  return [0, 1, 2, 3, 4, 5].map((grid) => slice * grid);
};

function capitalize(str) {
  return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
}

const getService = (service) => {
  const services = { desk: "support", crm: "sales", survey: "surveys" };
  return services[service] || service;
};

const allProducts = [
  {
    service: "desk",
    description: "Omnichannel Customer Support & Help Desk Software",
    features: [
      {
        title: "Omnichannel Inbox",
        description: "Streamline all customer conversations in one place",
      },
      {
        title: "Knowledge Base",
        description: "Automate your customer support with self service portal",
      },
      {
        title: "Advanced Ticketing",
        description:
          "Manage all your customer issues in one centralized dashboard",
      },
      {
        title: "Client Portal",
        description:
          "Proactively engage with customers with a personalized portal",
      },
      {
        title: "Workflows",
        description:
          "Automate your support operation with intelligent workflows",
      },
      {
        title: "Status Page",
        description: "Communicate incident management process and updates",
      },
    ],
  },
  {
    service: "chat",
    description: "AI Enabled Business Messaging and Chatbot Software",
    features: [
      {
        title: "Team Inbox",
        description: "Handle Multi-channels conversations at one unified inbox",
      },
      {
        title: "Knowledge Base",
        description: "Automate customer support with 24/7 self-service portal",
      },
      {
        title: "AI Chatbots",
        description:
          "Automate repetitive requests across website to improve customer support",
      },
      {
        title: "Messenger",
        description:
          "Engage is real time communication with website visitors to customers",
      },
      {
        title: "Campaigns",
        description:
          "Engage customers with email or message campaigns across multiple channels",
      },
      {
        title: "Video Chat",
        description:
          "Connect customer with 1-on-1 video chat for better support",
      },
    ],
  },
  {
    service: "crm",
    description: "Sales Engagement & CRM Software",
    features: [
      {
        title: "Sales Inbox",
        description: "Streamline all sales related communications at one inbox",
      },
      {
        title: "Sales Automation",
        description: "Automate various sales and CRM-related tasks",
      },
      {
        title: "Deals",
        description:
          "Visualize different stages of deals for tracking progress",
      },
      {
        title: "Sequences",
        description:
          "Build series of actions and touch points to engage customers",
      },
      {
        title: "Sales Forecasting",
        description: "Manage your sales pipeline and team targets effectively",
      },
      {
        title: "Quotes",
        description:
          "Implement tailored product quotation and close more deals",
      },
    ],
  },
  {
    service: "talk",
    description: "Call Center Software & Virtual Phone System",
    features: [
      {
        title: "Numbers",
        description:
          "Buy international numbers across 60+ countries in single click",
      },
      {
        title: "Call Widget",
        description:
          "Generate qualified leads instantly and boost your website conversions",
      },
      {
        title: "Power Dialer",
        description: "Scale your outbound calling with predictive dialer",
      },
      {
        title: "IVR",
        description:
          "Streamline customers support with multiple levels of IVR menu",
      },
      {
        title: "SMS Inbox & Campaigns",
        description: "Build personalized campaigns and manage SMS at one inbox",
      },
      {
        title: "Reporting & Analytics",
        description:
          "Review teams performance and track campaigns, for a better support experience",
      },
    ],
  },
  {
    service: "survey",
    description: "Customer Experience & Feedback Management Software",
    features: [
      {
        title: "Web & Email Surveys",
        description:
          "Collect customers valuable feedback across web & Email surveys",
      },
      {
        title: "In-app Surveys",
        description:
          "Collect customers feedback directly within your application",
      },
      {
        title: "Online Reviews",
        description:
          "Connect online reviews across 20+ platforms to build your online reputation",
      },
      {
        title: "Social Widget",
        description: "Showcase customers genuine reviews through social widget",
      },
      {
        title: "Case Management",
        description:
          "Convert your customer feedback into case and manage them in one place",
      },
      {
        title: "Reporting & Analytics",
        description:
          "Measure the performance of the surveys, team productivity for improvement",
      },
    ],
  },
  {
    service: "guide",
    description: "Product Marketing & Experience Platform",
    features: [
      {
        title: "Changelog",
        description:
          "Announce latest product changes and improve software user engagement",
      },
      {
        title: "NPS Surveys",
        description:
          "Get customer feedback and measure customer satisfaction with NPS Survey",
      },
      {
        title: "Feedback Management",
        description: "Manage all your customers feedback at one unified place",
      },
      {
        title: "Product Tours",
        description:
          "Assist users with interactive product tour and improve activation rate",
      },
      {
        title: "Goals",
        description: "Prepare roadmap and set ultimate goal for your product",
      },
      {
        title: "Reporting & Analytics",
        description: "Track the performance of your user onboarding",
      },
    ],
  },
];
export {
  maxOfGraph,
  getGridYValues,
  getGridYValuesMultipleBar,
  maxOfGraphMultipleBar,
  maxOfGraphBar,
  getGridYValuesBar,
  allProducts,
  capitalize,
  getService,
};
